import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from './auth/session';
import { ToastProvider } from './ui/kit';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { ApiError } from './api/client';
import { App } from './App';
import { installBrand } from './lib/brand';
import { installChunkReload } from './lib/chunkReload';
import { installScheme } from './lib/schemes';
import { installTruncationTitles } from './lib/truncation';
import { installTheme } from './lib/theme';
import './styles.css';
import './app.css';

installBrand();
installChunkReload();
installTheme();
installScheme();
installTruncationTitles();
const queryClient = new QueryClient({
  defaultOptions: {
    // Client errors (validation, not found, forbidden) will not change on a retry.
    queries: { retry: (count, error) => count < 2 && !(error instanceof ApiError && error.status < 500), refetchOnWindowFocus: false, staleTime: 15_000 },
  },
});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ToastProvider>
          <ErrorBoundary><App /></ErrorBoundary>
        </ToastProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
